<template>
  <section class="mt-16">
    <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>

      <h1 class="primary--text h1">
        <v-icon color="primary">mdi-notebook</v-icon> <span>{{$t('diaries.crumb_register')}}</span>
      </h1>

      <div class="mt-16">
        <diary method="create"></diary>
      </div>
  </section>
</template>
<script>
import Diary from '@/components/diaries/Diary'

export default {
  components: {
    Diary
  },
  beforeCreate(){
    document.title = "Report Lake - " + this.$t('diaries.crumb_register');
  },
  data: () => ({
    
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "diaries.create"])) {
      this.$router.push('/admin');
    }

  },
  methods:{
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: this.$t('menu.dashboard'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin',
          exact: true,
        },
        {
          text: this.$t('menu.daily_parts_management'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin/diaries',
          exact: true,
        },
        {
          text: this.$t('diaries.crumb_register'),
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
};
</script>
